import { render } from "./AboutMenuItem.vue?vue&type=template&id=97385968&scoped=true&ts=true"
import script from "./AboutMenuItem.vue?vue&type=script&lang=ts"
export * from "./AboutMenuItem.vue?vue&type=script&lang=ts"

import "./AboutMenuItem.vue?vue&type=style&index=0&id=97385968&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97385968"]])

export default __exports__